var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c("div", [
              _vm._v("\n            欄位底色： \n            "),
              _c("span", { style: { "background-color": "#FFFF00" } }, [
                _vm._v("時雨量達 40毫米以上")
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "filter_condition_options",
        fn: function() {
          return [
            _c("MonitorOptionSet", {
              ref: "monitor_option_set",
              attrs: { option_set: _vm.option_set },
              on: { filter_data: _vm.filter_data }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                show_download_pdf_btn: true,
                table_label_function: _vm.calc_accumulated_precp_level
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "table_description",
                    fn: function() {
                      return [
                        _c("span", [
                          _vm._v(' 說明："--"標示，顯示該欄位無資料。')
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }